// extracted by mini-css-extract-plugin
export default {"header":"ChartHeader_header__VsWal","flex2":"ChartHeader_flex2__94qar","flex1":"ChartHeader_flex1__exJXr"};